import React, { useMemo } from "react";
import TranslatedText from "../../core/TranslatedText";
import Separator from "../../core/Separator";
import FlexColumn from "../../core/FlexColumn";
import { useEntity } from "student-front-commons/src/hooks";
import { PROFILE_SCHEMA } from "student-front-commons/src/schemas";
import PropTypes from "prop-types";
import withTranslation from "../../core/withTranslation";
import Tooltip from "../../core/Tooltip";

function UnitGrammarItem({ grammar }) {
  const profile = useEntity(PROFILE_SCHEMA, sessionStorage.getItem("id"));
  const toolTipText = useMemo(() => {
    if (!grammar) return;
    return grammar.description.find((item) => item.locale === profile?.locale)?.value;
  }, [grammar]);

  if (!grammar) return null;

  if (toolTipText) {
    return (
      <Tooltip text={toolTipText}>
        <label role="listitem" style={{ fontSize: 13, color: "#607d8b", margin: 0, textAlign: "center" }}>
          {grammar.name}
        </label>
      </Tooltip>
    );
  }

  return (
    <label role="listitem" style={{ fontSize: 13, color: "#607d8b", margin: 0, textAlign: "center" }}>
      {grammar.name}
    </label>
  );
}

function UnitGrammars({ grammars }) {
  return (
    <FlexColumn minWidth={175} padding="0px 15px" alignItems="center">
      <TranslatedText
        as="label"
        translateKey="homeworks.list.listItem.grammars"
        style={{
          textTransform: "uppercase",
          fontSize: 11,
          color: "#727272",
          margin: 0,
        }}
      />
      <Separator size="sm" />
      <div
        role="list"
        style={{
          display: "grid",
          gap: 4,
          gridTemplateRows: "auto auto auto",
          gridTemplateColumns: "auto auto",
          gridAutoFlow: "column",
          textAlign: "center",
        }}
      >
        {grammars.map((grammar, index) => (
          <UnitGrammarItem key={`${grammar.id}-${index}`} grammar={grammar} />
        ))}
      </div>
    </FlexColumn>
  );
}

UnitGrammars.propTypes = {
  grammars: PropTypes.arrayOf(PropTypes.string),
};

export default withTranslation(UnitGrammars);
